__turbopack_context__.v({
  "chip": "_3K9Cxq_chip",
  "controls": "_3K9Cxq_controls",
  "explorer": "_3K9Cxq_explorer",
  "family": "_3K9Cxq_family",
  "find": "_3K9Cxq_find",
  "hint": "_3K9Cxq_hint",
  "legend": "_3K9Cxq_legend",
  "ours": "_3K9Cxq_ours",
  "refs": "_3K9Cxq_refs",
  "regions": "_3K9Cxq_regions",
  "row": "_3K9Cxq_row",
  "select": "_3K9Cxq_select",
  "surface": "_3K9Cxq_surface",
  "tip": "_3K9Cxq_tip",
  "tipCount": "_3K9Cxq_tipCount",
  "tipName": "_3K9Cxq_tipName",
  "zoom": "_3K9Cxq_zoom",
});
